import { Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { RoutingNames } from "./shared/enums/routes-names";
import { dashboardGuard } from "./b2c/guards/dashboard.guard";
import { ChainalysisComponent } from "./chainalysis/chainalysis.component";
import { authChainalysisGuard } from "./shared/guards/auth-chainalysis.guard";
import { PublicGuideComponent } from "./public-guide/public-guide.component";
import { VictimGuideDetailsComponent } from "./b2c/victim/guide/victim-guide-details/victim-guide-details.component";
import { VictimGuideComponent } from "./b2c/victim/guide/victim-guide/victim-guide.component";
import { OpsDocPoaAuthorizationComponent } from "./b2b/ops/dashboard/ops-document-editor/components/ops-doc-templates/common/ops-doc-poa-authorization/ops-doc-poa-authorization.component";
import { IndexComponent } from "./index/index.component";
import { indexGuard } from "./index/index.guard";
import { RegistrationComponent } from "./index/registration/registration.component";
import { ThankYouPageComponent } from "./case-submission/shared/thank-you/thank-you-page.component";

export const routes: Routes = [
  {
    path: "",
    title: "Partner portal - CYBERA™",
    component: IndexComponent,
    canActivate: [indexGuard],
  },
  {
    title: "Registration - CYBERA™",
    path: RoutingNames.B2C_REGISTER,
    component: RegistrationComponent,
    canActivate: [indexGuard],
  },
  {
    path: RoutingNames.CHAINALYSIS,
    loadComponent: () => ChainalysisComponent,
    canActivate: [authChainalysisGuard],
  },
  {
    path: RoutingNames.B2C_PERSONAL_GUIDE,
    title: "Guide - CYBERA™",
    loadComponent: () => PublicGuideComponent,
    children: [
      {
        path: ":reference",
        component: VictimGuideDetailsComponent,
      },
      {
        path: "",
        component: VictimGuideComponent,
      },
    ],
  },
  {
    path: RoutingNames.B2B,
    loadChildren: () => import("./b2b/client/client.routes").then((m) => m.CLIENT_ROUTES),
    canActivate: [MsalGuard],
  },
  {
    path: RoutingNames.B2B_OPS,
    canActivate: [MsalGuard],
    loadChildren: () => import("./b2b/ops/ops.routes").then((m) => m.OPS_ROUTES),
  },
  {
    title: "Report Case - CYBERA™",
    path: RoutingNames.CASE,
    loadChildren: () =>
      import("./case-submission/case-submission-wizard.routes").then(
        (m) => m.CASE_SUBMISSION_WIZARD_ROUTES,
      ),
  },
  {
    path: RoutingNames.B2C_PAID_SERVICE_THANK_YOU,
    loadComponent: () => ThankYouPageComponent,
  },
  {
    path: RoutingNames.B2C_PERSONAL_ROOT,
    canActivate: [MsalGuard, dashboardGuard],
    loadChildren: () => import("./b2c/victim/victim.routes").then((m) => m.VICTIM_ROUTES),
  },
  {
    path: RoutingNames.COMPLAINT_POA + "/:accessToken",
    loadComponent: () => OpsDocPoaAuthorizationComponent,
  },
  {
    path: RoutingNames.B2B_OPS_COMPLAINT_DOCUMENT + "/:accessToken",
    loadComponent: () =>
      import("./b2b/ops/dashboard/ops-document-pdf/ops-document.component").then(
        (m) => m.OpsDocumentComponent,
      ),
  },
];
